import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

import StatsDoughnut from './StatsDoughnut'

function StatsCircular({
  value = 0, maxValue = 0, displayValue, title, format = '0', tooltip, barColor, barBgColor, html = false,
}) {
  const chart = (
    <StatsDoughnut
      value={value}
      maxValue={maxValue}
      displayValue={displayValue}
      title={title}
      format={format}
      barColor={barColor}
      barBgColor={barBgColor}
    />
  )
  return (
    <Tooltip
      tooltipClassName="tooltip--stats-info"
      id={`dashboard__doughnut-info-${title}`}
      content={tooltip}
      place="right"
      delayHide={300}
      html={html}
    >
      {chart}
    </Tooltip>
  )
}

StatsCircular.propTypes = {
  value: PropTypes.number,
  maxValue: PropTypes.number,
  displayValue: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  barColor: PropTypes.string.isRequired,
  barBgColor: PropTypes.string.isRequired,
  format: PropTypes.string,
  html: PropTypes.bool,
}

export default StatsCircular
